import { TagsCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function TagFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <TagsCommandList multiselect selected={selection} onSelect={onSelect} />
}
